<div tabindex="-1">
  <div class="mb-3  text-left">
    <label class="mb-1 text-left pwned-text">{{ 'Common.PwnedInstructions' | translate }}</label>
    <a [href]="passwordAdviseUrl" target="_blank" class="pwned-link">
      {{ 'Common.PwnedLink' | translate }}
    </a>
  </div>
</div>
